import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { ITooltipParams } from "ag-grid-community";
import { ICcyLookupService } from "../../lookup/model/ICcyLookupService";

export class DIReasonHelper {
  // can interpolate params be used for this?
  static formatAmountArgumentMessageId: Map<string, Array<number>> = new Map([
    // array contains argument index needing formatting
    ["si.txn.limit.fill.received.not.triggered", [2]],
    ["si.txn.limit.fill.received.outside.tolerance", [5]],
    ["si.txn.limit.fill.received.outside.tolerance.no.trigger", [4]],
  ]);

  static tooltipItemMap = new WeakMap<object, object>();

  constructor(private _translate: TranslateService, private _ccyLookup?: ICcyLookupService) {
    //   this._translate = translate;
  }

  getValue(item: any, columnProperty: string): any {
    try {
      if (item[columnProperty] && item[columnProperty].errorMessages) {
        if (item[columnProperty].errorMessages.length != null) {
          return item[columnProperty].errorMessages.map((errorMessage) => JSON.parse(errorMessage));
        }
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  preprocessMessage(item, columnProperty, message) {
    // let cloned = false;
    if (
      DIReasonHelper.formatAmountArgumentMessageId.has(message["id"]) &&
      Array.isArray(message["args"])
    ) {
      // allow tooltip to retrieve item, so it can preprocess
      DIReasonHelper.tooltipItemMap.set(item[columnProperty], item);

      for (let index of DIReasonHelper.formatAmountArgumentMessageId.get(message["id"])) {
        if (index < message["args"].length) {
          // if (cloned === false) {
          //   message = Object.assign({}, message, {
          //     args: message['args'].slice(0)
          //   });
          //   cloned = true;
          // }

          let amt = new CubiqTS.BigNumber(message["args"][index]);
          let formattedAmt;

          if (item.orderData != null && item.orderData instanceof CubiqTS.OrderDataImpl) {
            let precision: number = 0;
            if (this._ccyLookup) {
              let ccy = this._ccyLookup.getCcy(item.orderData.fixedCcy);
              if (ccy && amt.decimalPlaces() != 0) {
                precision = ccy.minorUnitsQty.toNumber();
              }
            }
            formattedAmt = amt.toFormat(precision);
          } else {
            formattedAmt = new CubiqTS.BigNumber(message["args"][index]).toFormat(0);
          }
          message["args"][index] = formattedAmt;
        }
      }
    }

    // inplace but return in case of future map use
    return message;
  }

  retrieveData(item: any, columnProperty: string, joinLines: boolean = false): string {
    let messages = this.getValue(item, columnProperty);
    if (Array.isArray(messages)) {
      let diReason = "";
      let multiline = messages.length > 1;

      if (joinLines && multiline) {
        for (const [index, message] of messages.entries()) {
          if (message !== null && message.id.length > 0 && this._translate !== null) {
            let diReasonLine: string = this._translate.instant(message["id"], message["args"]);
            diReason += diReasonLine.trimEnd();
            diReason += diReason.endsWith(`.`) ? ` ` : `. `;
          }
        }
        return diReason;
      }

      if (multiline) {
        // add preamble
        diReason = `(${messages.length}) ${diReason}`;
      } else if (messages.length > 0) {
        try {
          let message = this.preprocessMessage(item, columnProperty, messages[0]);
          diReason = this._translate.instant(message["id"], message["args"]);
        } catch (e) {
          logger.out.warn(
            `${this.constructor.name}: Attempted to translate DI Reason failed: ${messages[0]}`,
          );
        }
      }

      return diReason;
    } else {
      return "";
    }
  }

  retrieveTooltip(params: ITooltipParams): string {
    let messages =
      params != null && params.value != null && Array.isArray(params.value.errorMessages)
        ? params.value.errorMessages.map((errorMessage) => JSON.parse(errorMessage))
        : null;
    if (Array.isArray(messages)) {
      let diReason = "";
      let item = DIReasonHelper.tooltipItemMap.get(params.value);

      for (let [index, message] of messages.entries()) {
        if (message !== null && message.id.length > 0 && this._translate !== null) {
          if (item != null) {
            message = this.preprocessMessage(item, "errors", message);
          }
          let diReasonLine: string = this._translate.instant(message["id"], message["args"]);
          diReason += diReasonLine;
          diReason += "\n";
        }
      }
      return diReason;
    } else {
      return "";
    }
  }
}
